import Layout from "../UI/Layout/Layout";
import Hero from "../UI/Hero/Hero";
import hero from "../../assets/image/areas/hero.webp";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import Intro from "./Intro/Intro";
import Overview from "./Overview/Overview";
import Container from "../UI/Container/Container";
import Seo from "../UI/Seo/Seo";

const SubjectAreas = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <Layout authLevelRequired={false}>
      <Seo
        title="Fachgebiete"
        description="Unsere Rechtsgebiete: von Arbeits-, Familien- und Erbrecht über Medizin- und Verkehrsrecht bis zu Datenschutz, gewerblichem Rechtsschutz und Gesellschaftsrecht."
        path="/fachgebiete"
      />
      <div>
        <Hero
          image={hero}
          small
          subtitle={t.subjectAreas.hero.subtitle}
          title={t.subjectAreas.hero.title}
        />
        <Intro />
        <Container>
          <Overview />
        </Container>
      </div>
    </Layout>
  );
};

export default SubjectAreas;
